import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-penandruller-icon',
  templateUrl: './design-penandruller.component.html'
})
export class DesignPenAndRullerComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
